// extracted by mini-css-extract-plugin
module.exports = {"m--wrapper":"Pagination_m--wrapper__lju4S","m--controls":"Pagination_m--controls__DQXhY","m--divider":"Pagination_m--divider__JXgPN"};